import _CircularProgress from "@mui/material/CircularProgress";
import _Skeleton from "@mui/material/Skeleton";
import _Typography from "@mui/material/Typography";
import _Box from "@mui/material/Box";
import _ButtonBase from "@mui/material/ButtonBase";
import _useMediaQuery from "@mui/material/useMediaQuery";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { useTheme } from '@mui/material/styles';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import daysImage from '../../assets/images/challenges/days.svg';
import workImage from '../../assets/images/challenges/work.svg';
import { useChallenge } from '../../hooks';
import { Button as CustomButton } from '../button';
import { CalendarIcon, CupIcon, GeoveloIcon, LinkIcon } from '../icons';
import { PhotosDialog } from '../photos-dialog';
import { ChallengeCollabationTypeChip, challengeCollaborationTypesMap } from './collabation-type-chip';
import { ChallengeCardData } from './data';
export const defaultChallengesImages = {
  cyclingDays: daysImage,
  traveledDistance: workImage,
  homeWorkJourneysCount: workImage,
  journeysCount: workImage,
  noTarget: '',
  bttf: '',
  custom: ''
};
export function ChallengeCard({
  Button: _Button,
  Dialog,
  Link,
  isModel,
  containerProps,
  imagePosition,
  disableLink,
  disableTitle,
  disableDescription,
  enableCollaborationType,
  disableProgression,
  enableUserProgression,
  enableMembersCount,
  enableProgressionHighlight,
  enableProgressionDescription,
  enableDescriptionLink,
  geogroup,
  challenge,
  userChallenge,
  redirectLink,
  activateButtonDisabled,
  handleActivate,
  handleClick
}) {
  const [photosDialogOpen, openPhotosDialog] = useState(false);
  const [showedPhotos, showPhotos] = useState(null);
  const {
    t
  } = useTranslation();
  const theme = useTheme();
  const isSmall = _useMediaQuery(theme.breakpoints.down('md'));
  const {
    getProgressValue
  } = useChallenge();
  function handlePhotosDialogOpen() {
    if (!challenge || !challenge.photo) return;
    showPhotos([{
      url: challenge.photo
    }]);
    openPhotosDialog(true);
  }
  function handlePhotosDialogClose() {
    openPhotosDialog(false);
    setTimeout(() => showPhotos(null), theme.transitions.duration.leavingScreen);
  }
  const imageOnLeft = imagePosition === 'left' && !isSmall;
  const collaborationType = challenge ? challengeCollaborationTypesMap[challenge.isLocal ? 'local' : challenge.collaborationType === 'teams' ? challenge.subGroupDisplay === 'companySite' ? 'sites' : 'teams' : challenge.collaborationType] || null : undefined;
  const Button = _Button || CustomButton;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Box, _extends({
    bgcolor: "#fff",
    border: "1px solid #e3e7ee",
    borderRadius: 4,
    display: "flex",
    flexDirection: "row",
    flexGrow: 1,
    maxWidth: "100%",
    overflow: "hidden"
  }, containerProps), /*#__PURE__*/React.createElement(_ButtonBase, {
    className: "challenge-card",
    component: challenge && !disableLink && !handleActivate && Link || 'div',
    disableRipple: !challenge || disableLink && !handleClick || Boolean(handleActivate),
    onClick: handleClick,
    sx: {
      alignItems: 'stretch',
      cursor: !challenge || disableLink && !handleClick || handleActivate ? 'default' : undefined,
      display: 'flex',
      flexDirection: imageOnLeft ? 'row' : 'column',
      flexGrow: 1,
      maxWidth: '100%',
      overflow: 'hidden',
      textAlign: 'left',
      '.MuiTouchRipple-root': {
        zIndex: 3
      }
    },
    to: redirectLink || (challenge ? challenge.isLocal ? `/challenges/${challenge.id}?group=${challenge.group}` : `/challenges/${challenge.id}` : undefined)
  }, imagePosition !== 'none' && /*#__PURE__*/React.createElement(_Box, {
    flexShrink: 0,
    sx: {
      ...(handleActivate ? {
        filter: 'grayscale(100%)'
      } : {})
    },
    width: imageOnLeft ? '50%' : '100%'
  }, /*#__PURE__*/React.createElement(_Box, {
    height: imageOnLeft ? '100%' : undefined,
    minHeight: imageOnLeft ? 300 : undefined,
    paddingTop: imageOnLeft ? undefined : '40%',
    position: "relative"
  }, challenge ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Box, {
    component: disableLink && !isModel && challenge.photo ? _ButtonBase : 'div',
    height: "100%",
    left: 0,
    onClick: () => disableLink && !isModel && challenge.photo && handlePhotosDialogOpen(),
    position: "absolute",
    sx: {
      backgroundImage: `url(${challenge.photo || defaultChallengesImages[challenge.type]})`,
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover'
    },
    top: 0,
    width: "100%",
    zIndex: 1
  }), imageOnLeft && collaborationType && /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    alignSelf: "flex-start",
    bgcolor: collaborationType?.bgColor,
    border: `0 1px 1px 0 solid ${collaborationType?.borderColor}`,
    borderRadius: "0 0 16px 0",
    color: collaborationType?.color,
    display: "flex",
    gap: 1,
    left: 0,
    padding: 1.5,
    position: "absolute",
    top: 0,
    zIndex: 1
  }, /*#__PURE__*/React.createElement(collaborationType.Icon, {
    color: "inherit",
    fontWeight: 600,
    sx: {
      height: 16,
      width: 16
    }
  }), /*#__PURE__*/React.createElement(_Typography, {
    color: "inherit",
    fontWeight: 600,
    variant: "body2"
  }, t(collaborationType.labelKey)))) : /*#__PURE__*/React.createElement(_Skeleton, {
    height: "100%",
    sx: {
      left: 0,
      position: 'absolute',
      top: 0
    },
    variant: "rectangular",
    width: "100%"
  }))), /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    gap: 3,
    overflow: "hidden",
    padding: 4,
    sx: {
      ...(handleActivate ? {
        bgcolor: '#F6F8FC'
      } : {})
    }
  }, /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    gap: 3,
    sx: {
      ...(handleActivate ? {
        filter: 'grayscale(100%)'
      } : {})
    }
  }, /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 2
  }, !imageOnLeft && /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 2,
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(ChallengeCollabationTypeChip, {
    collaborationType: collaborationType
  }), challenge && 'eventId' in challenge && challenge.eventId && /*#__PURE__*/React.createElement(GeoveloIcon, {
    fontSize: "large"
  })), /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 1
  }, !disableTitle && /*#__PURE__*/React.createElement(_Typography, {
    noWrap: true,
    fontSize: "1.25rem",
    fontWeight: 600,
    title: challenge?.title
  }, challenge ? challenge.title : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 200
  })), !disableDescription && /*#__PURE__*/React.createElement(_Box, null, (!challenge || challenge.description) && /*#__PURE__*/React.createElement(_Typography, {
    sx: !disableLink ? {
      display: '-webkit-box',
      WebkitLineClamp: '3',
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    } : {},
    variant: "body2"
  }, challenge?.description || /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: "100%"
  }), /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: "90%"
  }))), enableDescriptionLink && challenge?.detailsUrl && /*#__PURE__*/React.createElement(_Box, {
    marginTop: 1
  }, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    href: challenge.detailsUrl,
    rel: "noreferrer",
    size: "small",
    startIcon: /*#__PURE__*/React.createElement(LinkIcon, null),
    target: "_blank",
    variant: "text"
  }, t('commons.actions.more_informations')))))), /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: {
      xs: 1,
      md: 2
    }
  }, !isModel ? /*#__PURE__*/React.createElement(ChallengeCardData, {
    Button: Button,
    challenge: challenge,
    Dialog: Dialog,
    disableProgression: disableProgression,
    enableCollaborationType: enableCollaborationType,
    enableMembersCount: enableMembersCount,
    enableProgressionDescription: enableProgressionDescription,
    enableProgressionHighlight: enableProgressionHighlight,
    enableUserProgression: enableUserProgression,
    geogroup: geogroup,
    userChallenge: userChallenge
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 2
  }, /*#__PURE__*/React.createElement(CalendarIcon, {
    color: "primary",
    fontSize: "small"
  }), /*#__PURE__*/React.createElement(_Typography, {
    noWrap: true,
    fontWeight: 600,
    variant: "body2"
  }, t('commons.periods.month', {
    count: challenge?.endDate.diff(challenge.endDate, 'month')
  }))), (!challenge || challenge.collaborationType === 'global') && /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 2
  }, /*#__PURE__*/React.createElement(CupIcon, {
    color: "primary",
    fontSize: "small"
  }), /*#__PURE__*/React.createElement(_Typography, {
    noWrap: true,
    fontWeight: 600,
    variant: "body2"
  }, challenge ? getProgressValue(challenge.type, challenge.targetValue) : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 100
  })))))), handleActivate && /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    disabled: activateButtonDisabled,
    onClick: handleActivate,
    size: "medium",
    startIcon: activateButtonDisabled && /*#__PURE__*/React.createElement(_CircularProgress, {
      color: "inherit",
      size: 16,
      thickness: 4
    }),
    variant: "contained"
  }, "Activer ce challenge")))), /*#__PURE__*/React.createElement(PhotosDialog, {
    onClose: handlePhotosDialogClose,
    open: photosDialogOpen,
    photos: showedPhotos
  }));
}
export { ChallengeCardData, ChallengeCollabationTypeChip, challengeCollaborationTypesMap };